import { render, staticRenderFns } from "./AuthSignInForm.vue?vue&type=template&id=53e349a4&"
import script from "./AuthSignInForm.vue?vue&type=script&lang=js&"
export * from "./AuthSignInForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports